module.exports = __webpack_public_path__ + "static/media/4.690c0713.jpg";